import * as React from "react";
import { PriceViewGridBase } from "./styles";

interface PriceViewsProps {
	price: string;
	originPrice?: string;
	className?: string;
	isFlash?: boolean;
	originPriceBr?: Boolean;
}

export const PriceViews = (props: PriceViewsProps) => {
	const { price, originPrice, className = "", isFlash, originPriceBr } = props;
	return (
		<PriceViewGridBase key={"PriceViews"} className={className} isFlash={isFlash}>
			<span className={"currentPrice"}>{price}</span>
			{originPriceBr && <br />}
			{price !== originPrice && <span className={"originPrice"}>{originPrice}</span>}
		</PriceViewGridBase>
	);
};
